import { DateFnsLocaleProvider } from '@if/core/date'
import { DialogProvider, ErrorProvider, SnackbarProvider } from '@if/mui'
import LocaleProvider from '@src/components/common/LocaleProvider'
import { BrowserRouter as Router } from 'react-router-dom'
import FeatureFlagsGate from './FeatureFlagsGate' // #62287
import TopLevelRoutes from './Routes'
import ThemeProvider from './ThemeProvider'
import UserProvider from './UserProvider'
import AlertBannerOnDeprecatedStatus from './components/AlertBannerOnDeprecatedStatus'
import AlertBannerOnProduction from './components/AlertBannerOnProduction'

const App = () => {
  return (
    <FeatureFlagsGate>
      <UserProvider>
        <ThemeProvider>
          <SnackbarProvider>
            <DialogProvider>
              <ErrorProvider>
                <DateFnsLocaleProvider>
                  <LocaleProvider>
                    <Router>
                      <AlertBannerOnProduction />
                      <AlertBannerOnDeprecatedStatus />
                      <TopLevelRoutes />
                    </Router>
                  </LocaleProvider>
                </DateFnsLocaleProvider>
              </ErrorProvider>
            </DialogProvider>
          </SnackbarProvider>
        </ThemeProvider>
      </UserProvider>
    </FeatureFlagsGate>
  )
}

export default App
